import { render, staticRenderFns } from "./SettingsOverlay.vue?vue&type=template&id=6ad128b8"
import script from "./SettingsOverlay.vue?vue&type=script&lang=js"
export * from "./SettingsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports